

import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { ICountries, IStepTwo } from './types/StepTwo-inerface'

const StepTwoState = (state: RootState): IStepTwo => state.StepTwoCancer

export const FormFieldsStepTwo = createSelector(
    [StepTwoState],
    (state): IStepTwo => state,
)
export const CountriesData = createSelector(
    [StepTwoState],
    (state): ICountries => state.Countries,
)


